'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProps = _interopRequireWildcard(_renderProp);

var _Functions = require('../core/Functions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var activeContextValue = { transitioning: true };
var inactiveContextValue = { transitioning: false };
var getContextValue = function getContextValue(transitioning) {
  return transitioning ? activeContextValue : inactiveContextValue;
};

var TwoWayTransition = function (_React$Component) {
  _inherits(TwoWayTransition, _React$Component);

  function TwoWayTransition(props) {
    _classCallCheck(this, TwoWayTransition);

    var _this = _possibleConstructorReturn(this, (TwoWayTransition.__proto__ || Object.getPrototypeOf(TwoWayTransition)).call(this, props));

    var children = props.children,
        transitionOnMount = props.transitionOnMount;

    _this.state = {
      cachedChildren: children,
      hidden: transitionOnMount ? children != null : children == null,
      transitioning: false,
      transitionActive: false,
      opening: false,
      closing: false
    };
    _this.stopTransition = _this.stopTransition.bind(_this);
    _this._t = 0;
    return _this;
  }

  _createClass(TwoWayTransition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      var _props = this.props,
          children = _props.children,
          duration = _props.duration,
          onOpenStart = _props.onOpenStart,
          onOpenComplete = _props.onOpenComplete,
          transitionOnMount = _props.transitionOnMount;

      if (transitionOnMount) {
        this.startTransition(children == null, duration);
      } else if (children != null) {
        (0, _Functions.callIfPossible)(onOpenStart);
        (0, _Functions.callIfPossible)(onOpenComplete);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          children = _props2.children,
          duration = _props2.duration,
          transitionOnUpdate = _props2.transitionOnUpdate;

      // ⚠️ This condition prevents infinite loops! ⚠️

      if (prevProps.children === children) return;

      if (children != null) {
        this.cacheChildren(children);
      }

      if (transitionOnUpdate) {
        if (prevProps.children == null && children != null) {
          this.startTransition(false, duration);
        } else if (prevProps.children != null && children == null) {
          this.startTransition(true, duration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      cancelAnimationFrame(this._frame);
    }
  }, {
    key: 'cacheChildren',
    value: function cacheChildren(children) {
      if (children === this.state.cachedChildren) return;
      this.setState({
        cachedChildren: children
      });
    }
  }, {
    key: 'startTransition',
    value: function startTransition(hidden, duration) {
      var _this2 = this;

      var _props3 = this.props,
          onOpenStart = _props3.onOpenStart,
          onCloseStart = _props3.onCloseStart;


      if (hidden) {
        (0, _Functions.callIfPossible)(onCloseStart);
      } else {
        (0, _Functions.callIfPossible)(onOpenStart);
      }

      // Clear any other pending timers on the component
      cancelAnimationFrame(this._frame);
      clearTimeout(this._timeout);

      // If duration={0}, skip the CSS transition entirely (#6542)
      if (duration === 0) {
        this.setState({ hidden: hidden });
        this.stopTransition(hidden);
        return;
      }

      // Edge case: If startTransition() is called again before the setState() callback fires, abort.
      this._t += 1;
      var setStateHandle = this._t;

      this.setState({ transitioning: true }, function () {
        if (setStateHandle !== _this2._t) return;
        // Normally, two RAFs are the correct amount of time to wait before applying style changes to
        // trigger a transition. However, we need three to allow React changes to flush to the DOM.
        _this2._frame = requestAnimationFrame(function () {
          _this2._frame = requestAnimationFrame(function () {
            _this2._frame = requestAnimationFrame(function () {
              if (!_this2._isMounted) return;
              _this2.setState({
                hidden: hidden,
                closing: hidden,
                opening: !hidden,
                transitionActive: true
              });
              _this2._timeout = setTimeout(_this2.stopTransition, duration);
            });
          });
        });
      });
    }
  }, {
    key: 'stopTransition',
    value: function stopTransition(forceHidden) {
      var _props4 = this.props,
          onOpenComplete = _props4.onOpenComplete,
          onCloseComplete = _props4.onCloseComplete;
      var hidden = this.state.hidden;

      // In the duration={0} scenario, state has not yet flushed, so we pass it explicitly.

      var computedHidden = forceHidden != null ? forceHidden : hidden;

      if (computedHidden) (0, _Functions.callIfPossible)(onCloseComplete);
      if (!this._isMounted) return;
      if (!computedHidden) (0, _Functions.callIfPossible)(onOpenComplete);

      this.setState({
        transitioning: false,
        transitionActive: false
      });
      if (computedHidden) {
        this.cacheChildren(null);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          ContextProvider = _props5.ContextProvider,
          __onOpenStart = _props5.onOpenStart,
          __onOpenComplete = _props5.onOpenComplete,
          __onCloseStart = _props5.onCloseStart,
          __onCloseComplete = _props5.onCloseComplete,
          transitionOnMount = _props5.transitionOnMount,
          __transitionOnUpdate = _props5.transitionOnUpdate,
          children = _props5.children,
          duration = _props5.duration,
          Wrapper = _props5.Wrapper,
          rest = _objectWithoutProperties(_props5, ['ContextProvider', 'onOpenStart', 'onOpenComplete', 'onCloseStart', 'onCloseComplete', 'transitionOnMount', 'transitionOnUpdate', 'children', 'duration', 'Wrapper']);

      var _state = this.state,
          hidden = _state.hidden,
          cachedChildren = _state.cachedChildren,
          transitioning = _state.transitioning,
          transitionActive = _state.transitionActive,
          opening = _state.opening,
          closing = _state.closing;


      var isInitialTransitionPending = !this._isMounted && transitionOnMount;

      var renderedWrapper = _react2.default.createElement(
        Wrapper,
        _extends({
          duration: duration,
          hidden: hidden,
          opening: opening,
          closing: closing,
          transitioning: transitioning,
          transitionActive: transitionActive
        }, rest),
        children != null ? children : cachedChildren
      );

      return ContextProvider ? _react2.default.createElement(
        ContextProvider,
        {
          value: getContextValue(transitioning || isInitialTransitionPending)
        },
        renderedWrapper
      ) : renderedWrapper;
    }
  }]);

  return TwoWayTransition;
}(_react2.default.Component);

var wrapperPropTypes = {
  duration: _react.PropTypes.number,
  hidden: _react.PropTypes.bool.isRequired,
  transitioning: _react.PropTypes.bool.isRequired,
  transitionActive: _react.PropTypes.bool.isRequired,
  closing: _react.PropTypes.bool.isRequired,
  opening: _react.PropTypes.bool.isRequired
};

TwoWayTransition.propTypes = {
  children: _react.PropTypes.node,
  ContextProvider: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
  duration: _react.PropTypes.number.isRequired,
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  transitionOnMount: _react.PropTypes.bool.isRequired,
  transitionOnUpdate: _react.PropTypes.bool.isRequired,
  Wrapper: RenderProps.getPropType({ propTypes: { wrapperPropTypes: wrapperPropTypes } }).isRequired
};

TwoWayTransition.defaultProps = {
  children: null,
  transitionOnMount: false,
  transitionOnUpdate: true
};

TwoWayTransition.displayName = 'TwoWayTransition';

var PlainWrapper = function PlainWrapper(props) {
  var __duration = props.duration,
      __hidden = props.hidden,
      __transitioning = props.transitioning,
      __transitionActive = props.transitionActive,
      __opening = props.opening,
      __closing = props.closing,
      rest = _objectWithoutProperties(props, ['duration', 'hidden', 'transitioning', 'transitionActive', 'opening', 'closing']);

  return _react2.default.createElement('div', _extends({ 'data-transition-wrapper': true }, rest));
};

PlainWrapper.displayName = 'TwoWayTransition.PlainWrapper';

TwoWayTransition.PlainWrapper = PlainWrapper;

exports.default = TwoWayTransition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/transitions/TwoWayTransition.js
// module id = 168
// module chunks = 3 4 5